var map = {
	"./404.vue": 9893,
	"./About.vue": 4161,
	"./Games/ChineseChess.vue": 3532,
	"./Games/MineSweep copy.vue": 9974,
	"./Games/MineSweep.vue": 664,
	"./Games/demo.vue": 1015,
	"./Home.vue": 5064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;